// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingResponse

import { BookingStatus, GuaranteeStatus, BookingOrigin, ReconfirmationStatus } from './enums.gen';
import { hydratePayment, type Payment, type PaymentApiResponse } from './payment.gen';
import { hydrateBookingOffer, type BookingOffer, type BookingOfferApiResponse } from './bookingOffer.gen';
import { hydrateBookingSession, type BookingSession, type BookingSessionApiResponse } from './bookingSession.gen';
import { hydrateSurveyResult, type SurveyResult, type SurveyResultApiResponse } from './surveyResult.gen';
import { hydrateCustomerPackageUsage, type CustomerPackageUsage, type CustomerPackageUsageApiResponse } from './customerPackageUsage.gen';
import { hydrateCustomerWithBookings, type CustomerWithBookings, type CustomerWithBookingsApiResponse } from './customerWithBookings.gen';
import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BookingApiResponse = {
	id: string;
	date: string;
	status: BookingStatus;
	customerRequest: string | null;
	privateNote: string;
	payments: PaymentApiResponse[];
	guaranteed: GuaranteeStatus | null;
	guaranteedAmount: number | null;
	origin: BookingOrigin;
	offers: BookingOfferApiResponse[];
	sessions: BookingSessionApiResponse[];
	customerId: string | null;
	pax: number;
	unread: boolean;
	surveyResult: SurveyResultApiResponse | null;
	reconfirmationStatus: ReconfirmationStatus;
	promoCodeId: string | null;
	createdAt: string;
	splitPaymentDeadline: string | null;
	customFields: Record<string, string>;
	products: Record<string, number>;
	packageUsages: CustomerPackageUsageApiResponse[];
	customer: CustomerWithBookingsApiResponse | null;
};

export type Booking = {
	id: string;
	date: DateTime;
	status: BookingStatus;
	customerRequest: string | null;
	privateNote: string;
	payments: Payment[];
	guaranteed: GuaranteeStatus | null;
	guaranteedAmount: number | null;
	origin: BookingOrigin;
	offers: BookingOffer[];
	sessions: BookingSession[];
	customerId: string | null;
	pax: number;
	unread: boolean;
	surveyResult: SurveyResult | null;
	reconfirmationStatus: ReconfirmationStatus;
	promoCodeId: string | null;
	createdAt: DateTime;
	splitPaymentDeadline: DateTime | null;
	customFields: Record<string, string>;
	products: Record<string, number>;
	packageUsages: CustomerPackageUsage[];
	customer: CustomerWithBookings | null;
};

export function hydrateBooking(data: BookingApiResponse): Booking {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
		payments: data.payments.map(hydratePayment),
		offers: data.offers.map(hydrateBookingOffer),
		sessions: data.sessions.map(hydrateBookingSession),
		surveyResult: data.surveyResult ? hydrateSurveyResult(data.surveyResult) : null,
		createdAt: DateTimefromISO(data.createdAt)!,
		splitPaymentDeadline: DateTimefromISO(data.splitPaymentDeadline),
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
		products: Array.isArray(data.products) ? {} : data.products,
		packageUsages: data.packageUsages.map(hydrateCustomerPackageUsage),
		customer: data.customer ? hydrateCustomerWithBookings(data.customer) : null,
	};
}